import { render, staticRenderFns } from "./coupon-card.vue?vue&type=template&id=b5eb0d12"
import script from "./coupon-card.vue?vue&type=script&lang=js"
export * from "./coupon-card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports